var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { BorderRadius, Colors, InlineChildren, Inset, StackChildren, Text, } from '@doordash/design-language';
import styled from 'styled-components';
import OptInStrings from './OptInStrings';
import { EmailField } from '@doordash/component-fields';
import Button from '@doordash/component-button';
import { isEmailFormatValid } from '../../utils/validateEmailHelper';
import { OptInTestId } from '../testId';
import { KEY_CODES } from '../../constants/values';
var EnrollInputContainer = styled(Inset)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 90%;\n  max-width: 640px;\n  border-radius: ", "px;\n  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);\n  background-color: ", ";\n"], ["\n  width: 90%;\n  max-width: 640px;\n  border-radius: ", "px;\n  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);\n  background-color: ", ";\n"])), BorderRadius.Large, Colors.BackgroundPrimary);
var EnrollInput = function (_a) {
    var isMobile = _a.isMobile, isLoading = _a.isLoading, onEnroll = _a.onEnroll;
    var _b = __read(React.useState(''), 2), email = _b[0], setEmail = _b[1];
    var _c = __read(React.useState(''), 2), error = _c[0], setError = _c[1];
    var handleEmailChange = function (newEmail) {
        setError('');
        setEmail(newEmail);
    };
    var onEnrollClick = React.useCallback(function () {
        if (!email) {
            setError(OptInStrings.enrollErrors.fieldIsRequired());
            return;
        }
        var isEmailValid = isEmailFormatValid(email);
        if (!isEmailValid) {
            setError(OptInStrings.enrollErrors.enterValidEmail());
            return;
        }
        setError('');
        onEnroll(email);
    }, [email, onEnroll]);
    // submit email on enter
    var onEmailInputKeydown = React.useCallback(function (e) {
        if (e.keyCode === KEY_CODES.ENTER) {
            onEnrollClick();
        }
    }, [onEnrollClick]);
    // Display side-by-side on desktop, and top-bottom on mobile
    var InputEmailLineWrapper = isMobile ? StackChildren : InlineChildren;
    return (React.createElement(EnrollInputContainer, null,
        React.createElement(StackChildren, null,
            React.createElement(Text, { color: Text.Colors.TextPrimary, styles: Text.Styles.Label1Emphasis }, OptInStrings.enterWorkEmailAddress()),
            React.createElement(InputEmailLineWrapper, null,
                React.createElement(EmailField, { "data-testid": OptInTestId.EnrollEmailField, label: "Email", isLabelHidden: true, placeholder: OptInStrings.workEmailAddressPlaceholder(), value: email, onChange: handleEmailChange, onKeyDown: onEmailInputKeydown, error: error, isDisabled: isLoading, autoFocus: true }),
                React.createElement("div", null,
                    React.createElement(Button, { "data-testid": OptInTestId.EnrollButton, isInline: true, state: isLoading ? Button.States.Loading : Button.States.Default, onClick: onEnrollClick }, OptInStrings.enroll()))))));
};
export default EnrollInput;
var templateObject_1;
